import React, { Component } from 'react'
import { Icon } from 'antd'
import Details from './Details'

export default class Detail extends Component<any, any> {
    state = {
        open: false
    }
    toggleVisibility = () => {
        this.setState(prevState => ({ open: !prevState.open }))
    }
    render() {
        const { open } = this.state
        const { clinics } = this.props
        if (clinics && clinics.length) {
            let title
            if (clinics.length === 1) {
                title = 'נמצאה מרפאה אחת'
            } else {
                title = `נמצאו ${clinics.length} מרפאות`
            }
            return (
                <div style={{ cursor: 'pointer' }}>
                    <div style={{ textDecoration: 'underline' }} onClick={() => this.toggleVisibility()}>
                        <Icon type={open ? 'down' : 'left'} style={{ fontSize: '0.8rem', marginLeft: '0.5rem' }} />
                        <span>{title}</span>
                    </div>
                    <div
                        style={{
                            display: `${this.state.open ? 'flex' : 'none'}`,
                            paddingRight: '1.5rem',
                            flexDirection: 'column'
                        }}
                    >
                        <div>
                            {clinics.map((clinic, index) => (
                                <span key={index}>
                                    <Details {...clinic} />
                                </span>
                            ))}
                        </div>
                    </div>
                </div>
            )
        } else {
            return <span>לא נמצאו מרפאות</span>
        }
    }
}
